<template>
    <div>

        <fine-details-modal
                v-if="fineId"
                :showModal="showFineDetailsModal"
                :openModal="openFineDetailsModal"
                :closeModal="closeFineDetailsModal"
                :fineId="fineId"
        ></fine-details-modal>

        <if-details-modal
                v-if="ifId"
                :showModal="showIfDetailsModal"
                :openModal="openIfDetailsModal"
                :closeModal="closeIfDetailsModal"
                :ifId="ifId"
        ></if-details-modal>

        <!-- Modal for mercy result -->
        <modal v-if="mercyModel" :showModal="showMercyModal" :hideModal="closeMercyModal">

            <h5 slot="header">Détails de l'indulgence</h5>

            <div slot="body" class="w-100">

                <div class="row">
                    <div class="col-4"><b>Code :</b></div>
                    <div class="col-8">{{ mercyModel.code }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Date :</b></div>
                    <div class="col-8">{{ mercyModel.date }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Motif contrôle :</b></div>
                    <div class="col-8">{{ mercyModel.reason }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Motif indulgence :</b></div>
                    <div class="col-8">{{ mercyModel.mercyReason }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Observation :</b></div>
                    <div class="col-8">{{ mercyModel.observation }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Agent :</b></div>
                    <div class="col-8">{{ mercyModel.officer }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Station de départ :</b></div>
                    <div class="col-8">{{ mercyModel.station_start }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Lieu d'interpellation :</b></div>
                    <div class="col-8">{{ mercyModel.station_end }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Véhicule :</b></div>
                    <div class="col-8">{{ mercyModel.vehicle }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Type de véhicule :</b></div>
                    <div class="col-8">{{ mercyModel.vehicleType }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Ligne :</b></div>
                    <div class="col-8">{{ mercyModel.line }}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Type de contrôle :</b></div>
                    <div class="col-8">{{ mercyModel.controlType === 'moving' ? 'Embarqué' : 'Sol'}}</div>
                </div>

                <hr/>

                <div class="row">
                    <div class="col-4"><b>Type de tenue :</b></div>
                    <div class="col-8">{{ mercyModel.outfit === 'uniform' ? 'Uniforme' : 'Civil'}}</div>
                </div>

            </div>

            <div slot="footer">
                <button class="btn btn-danger" @click="closeMercyModal">Fermer</button>
            </div>

        </modal>

        <!-- Modal for no result -->
        <modal :showModal="showNotFoundModal" :hideModal="closeNotFoundModal">

            <h5 slot="header">Aucun Résultat</h5>

            <div slot="body" class="w-100">

                <div>Le code fourni ne correspond à aucun procès verbal, quittance ou indulgence.</div>

            </div>

            <div slot="footer">
                <button class="btn btn-danger" @click="closeNotFoundModal">Fermer</button>
            </div>

        </modal>

    </div>
</template>

<script>

    import axios from "axios";
    import Modal from './Modal';
    import FineDetailsModal from "./FineDetailsModal";
    import IfDetailsModal from "./IfDetailsModal";

    export default {
        components: {Modal, FineDetailsModal, IfDetailsModal},
        data() {
            return {
                isFound: false,
                showFineDetailsModal: false,
                showIfDetailsModal: false,
                showMercyModal: false,
                showNotFoundModal: false,
                fineId: null,
                ifId: null,
                mercyModel: null
            }
        },
        watch: {
            '$store.state.search': function() {
                if (this.$store.state.search > 0) {
                    this.search(this.$store.state.search);
                }
            }
        },
        methods: {

            async search(code) {
                this.isFound = false;
                await this.getFine(code);
                if (this.isFound === false) {
                    await this.getIf(code);
                    if (this.isFound === false) {
                        await this.getMercy(code);
                        if (this.isFound === false) {
                            this.showNotFoundModal = true;
                        }
                    }
                }
                await this.$store.commit("setSearchLoading", false);
                await this.$store.commit("search", "");
            },

            async getFine(fineCode) {
                await axios.get('/api/fines/' + fineCode + '?isClientId=true')
                    .then(result => {
                        if (Object.keys(result.data).length) {
                            this.fineId = result.data.id;
                            this.showFineDetailsModal = true;
                            this.isFound = true;
                        }
                    });
            },

            openFineDetailsModal(fineId) {
                this.fineId = fineId;
                this.showFineDetailsModal = true;
            },

            closeFineDetailsModal() {
                this.showFineDetailsModal = false;
            },

            async getIf(ifCode) {
                await axios.get('/api/ifs/' + ifCode + '?isClientId=true')
                    .then(result => {
                        if (Object.keys(result.data).length) {
                            this.ifId = result.data.id;
                            this.showIfDetailsModal = true;
                            this.isFound = true;
                        }
                    });
            },

            openIfDetailsModal(ifId) {
                this.ifId = ifId;
                this.showIfDetailsModal = true;
            },

            closeIfDetailsModal() {
                this.showIfDetailsModal = false;
            },

            async getMercy(mercyCode) {
                await axios.get('/api/mercies/' + mercyCode + '?isClientId=true')
                    .then(result => {
                        if (Object.keys(result.data).length) {
                            this.mercyModel = result.data;
                            this.showMercyModal = true;
                            this.isFound = true;
                        }
                    });
            },

            closeMercyModal() {
                this.showMercyModal = false;
            },

            closeNotFoundModal() {
                this.showNotFoundModal = false;
            }

        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/layout/InfringementSearchResultModal.vue